function loadFileUpload(uploadId) {
    const fileIdInput = document.querySelector(`[data-file-id="${uploadId}"]`);
    const fileInput = document.querySelector(`[data-file-select="${uploadId}"]`);
    const filePreview = document.querySelector(`[data-file-preview="${uploadId}"]`);

    if (fileIdInput && fileInput && filePreview) {
        console.log('File upload enabled');
        fileInput.addEventListener('change', async function () {
            console.log('File upload changed');
            const body = new FormData();
            body.append('uploadFile[file]', fileInput.files[0]);
            body.append('uploadFile[submit]', 'Upload');

            const response = await fetch(fileInput.dataset.uploadUrl, {
                method: 'POST',
                body,
            });

            if (!response.ok) {
                alert('Error uploading file');
                return;
            }

            const data = await response.json();

            if (!data.success) {
                alert('Error uploading file');
                return;
            }

            fileIdInput.value = data.id;
            filePreview.src = filePreview.dataset.baseUrl + data.id;
        });
    } else {
        console.log('File upload disabled', {
            fileIdInput,
            fileInput,
            filePreview,
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const fileUploads = document.querySelectorAll('[data-file-id]');

    fileUploads.forEach(input => {
        loadFileUpload(input.getAttribute('data-file-id'));
    });
});
